import EditMyCompanyUserPage from './EditMyCompanyUserPage';
import { createEditMyCompanyUserHandle } from './handle';

export default {
  Component: EditMyCompanyUserPage,
  createHandle: createEditMyCompanyUserHandle
};
